import React, { useCallback } from "react";
import { CustomCellRendererProps } from "@ag-grid-community/react";
import { Directions } from "@mui/icons-material";
import { IconButton, Stack, Tooltip } from "@mui/material";

import { SpliceRecord, SpliceRecordLeaf } from "fond/topologicalView/types";
import { LayerIds } from "fond/types";

import { useTopologicalViewContext } from "./TopologicalViewContext";

type Props = Pick<CustomCellRendererProps<SpliceRecord, SpliceRecordLeaf>, "value">;

/**
 * Renderer for the leaf node cell.
 *
 * This is used to display service locations or other terminal nodes in the topology.
 */
const LeafRenderer: React.FC<Props> = ({ value }) => {
  const { selectFeature } = useTopologicalViewContext();

  const viewFeature = useCallback(() => {
    if (value?.id) {
      selectFeature(
        { id: value.id, layerKey: LayerIds.serviceLocation },
        {
          zoomMap: true,
          highlightFeature: true,
          showProperties: true,
        }
      );
    }
  }, [selectFeature, value?.id]);

  if (!value) {
    return null;
  }

  return (
    <Stack justifyContent="center" alignItems="center" direction="row">
      {value.label}
      {value?.id && (
        <Tooltip title="View feature" arrow>
          <IconButton data-testid="view-feature-button" size="small" color="primary" onClick={viewFeature}>
            <Directions style={{ fontSize: "18px" }} />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};

export default LeafRenderer;
